module.exports = __webpack_public_path__ + "img/no-data.6ef36533.png";